import { FC } from 'react';
import { useMutation } from 'react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import SelectComponent from 'components/Inputs/SelectComponent';
import { languagesOptions } from 'constants/langs';
import { TempLangType } from 'types/common';
import { profileTranslations } from './translations';
import { ProfileTransFields } from './types';
import styles from './profile.module.scss';
import { IOption } from 'components/Inputs/SelectComponent/types';

const Profile: FC = () => {
  const {
    mainStore: { changeLanguage },
    alertStore: { showAlert },
  } = useStore();

  const { i18n, t } = useMyTranslations<ProfileTransFields>([profileTranslations.name]);

  const { isLoading, mutate } = useMutation(changeLanguage, {
    mutationKey: 'changeLanguage',
    onSuccess: () => {
      showAlert(t('successMsg'), 'success');
    },
  });

  const useFormMethods = useForm<{ lang: IOption<TempLangType> }>({
    defaultValues: { lang: languagesOptions.find((option) => option.value === i18n.language) },
  });
  const { setValue } = useFormMethods;

  const onChange = async (val: IOption<TempLangType>) => {
    setValue('lang', val);
    mutate(val.value);
  };

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.container}>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <FormProvider {...(useFormMethods as any)}>
          <form className={styles.form}>
            <section className={`${styles.formSection}`}>
              <h6 className={`${styles.title} ${styles.titleWithMargin}`}>{t('formTitle')}</h6>
              <SelectComponent
                name='lang'
                options={languagesOptions}
                placeholder=''
                isClearable={false}
                isDisabled={isLoading}
                onSelect={(val) => onChange(val as IOption<TempLangType>)}
              />
            </section>
          </form>
        </FormProvider>
      </div>
    </main>
  );
};

export default Profile;
